export const locale = (state) => {
	return state.locale
}
